import request from '@/utils/request'

// 获取配置列表
export async function api_getPageConfigList(params) {
  return request({
    url: '/rest/page/config/list',
    method: 'get',
    params,
  })
}
// 修改配置
export async function api_putUpdateConfig(data) {
  return request({
    url: '/rest/page/config',
    method: 'put',
    data,
  })
}

// 获取配置详情
export async function api_getConfigDatil(params) {
  return request({
    url: '/rest/page/config',
    method: 'get',
    params,
  })
}

// 新增配置
export async function api_postCreatedConfig(data) {
  return request({
    url: '/rest/page/config',
    method: 'post',
    data,
  })
}

// 删除配置
export async function api_deleteConfig(params) {
  return request({
    url: '/rest/page/config',
    method: 'delete',
    params,
  })
}
